import React from 'react';
import { Grid, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GridDashboardWrapper } from '../shared/all.styles';
import { WidgetNumber } from '../components/WidgetNumber';
import useHomeData from '../hook/useHomeData';
import { WidgetNewestUpdatedClusters } from '../components/WidgetNewestUpdatedClusters';
import { WidgetReviewPerHospital } from '../components/WidgetReviewPerHospital';
import { useNavigate } from 'react-router-dom';
import { WidgetFusionCandidate } from '../components/WidgetFusionCandidates';
const Home = () => {
  const { t } = useTranslation();

  const {
    clustersCount,
    newestClusters,
    productsCount,
    toReviewCount,
    toReviewHospitalDistr,
    fusionClusters,
    isLoading,
    isError,
  } = useHomeData();

  const navigate = useNavigate();

  return (
    <>
      <Stack
        direction="row"
        ml={'20px'}
        alignItems={'center'}
        justifyContent="space-between"
        spacing={1}
        marginBottom={2}
      >
        <Stack direction={'row'} alignItems={'center'} spacing={4} height={'56px'}>
          <Typography variant="h4" color="inherit">
            {t('home.title')}
          </Typography>
        </Stack>
      </Stack>
      <GridDashboardWrapper container spacing={2}>
        <Grid item xs={4} height="25%">
          <WidgetNumber
            title={t('home.clusterCount')}
            value={clustersCount.data}
            color={false ? 'error.main' : 'success.main'}
            loading={isLoading}
            onLinkClick={() => {
              navigate('/clusters');
            }}
          />
        </Grid>
        <Grid item xs={4} height="25%">
          <WidgetNumber
            title={t('home.productCount')}
            value={productsCount.data}
            color={false ? 'error.main' : 'success.main'}
            loading={isLoading}
            onLinkClick={() => {
              navigate('/products');
            }}
          />
        </Grid>
        <Grid item xs={4} height="25%">
          <WidgetNumber
            title={t('home.productToReview')}
            value={toReviewCount.data}
            color={'warning.main'}
            loading={isLoading}
            onLinkClick={() => {
              navigate('/products');
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <WidgetNewestUpdatedClusters
            title={t('home.recentUpdatedCluster')}
            values={newestClusters?.data?.data}
            loading={isLoading}
            onLinkClick={(filter: any) => {
              navigate(
                '/clusters',
                filter ? { state: { stateFilters: { cluster_id: filter } } } : {},
              );
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <WidgetReviewPerHospital
            title={t('home.reviewPerHospital')}
            values={toReviewHospitalDistr?.data}
            loading={isLoading}
          />
        </Grid>
        <Grid item xs={4}>
          <WidgetFusionCandidate
            title={t('home.fusionCandidateCLusters')}
            values={fusionClusters.data?.data}
            loading={isLoading}
            onLinkClick={(filter: any) => {
              navigate(
                '/clusters',
                filter ? { state: { stateFilters: { cluster_id: filter } } } : {},
              );
            }}
          />
        </Grid>
      </GridDashboardWrapper>
    </>
  );
};

export default Home;
